export default __webpack_public_path__ + "static/media/rnb-ig.994b8b22.webp";